<template>
	<div class="job-evaluation-level">
		<div>
			<div class='tw-mb-4'>
				<label>Rol</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.role.data"
					v-model="jobCopied.role"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Titulación Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.title.data"
					v-model="jobCopied.title"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Exp. Profesional Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.experience.data"
					v-model="jobCopied.experience"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Nivel de Inglés</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.englishLevel.data"
					v-model="jobCopied.englishLevel"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Área al que pertenece el puesto</label>
				<div class="tw-flex tw-justify-center tw-items-center tw-gap-x">
					<v-select
						solo
						autocomplete
						class="custom-select"
						item-text="name"
						item-value="id"
						:items="groups"
						v-model="jobCopied.areaId"
						@change="onSelectChange"
					></v-select>
					<app-button
						class="btn-tool"
						icon="add"
						:style="`background-color:${$appColors.primary}`"
						@click="addArea"
					/>
				</div>
			</div>
			<div class='tw-mb-4'>
				<label>Jefe inmediato</label>
				<v-select
					solo
					class="custom-select"
					autocomplete
					item-text="name"
					item-value="id"
					:items="jobsFilter"
					v-model="jobCopied.additionalInformation.immediateBoss"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Puesto al que Remplaza</label>
				<v-select
					solo
					multiple
					chips
					deletable-chips
					autocomplete
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="jobList"
					v-model="jobCopied.additionalInformation.jobHeReplaces"
					@change="onSelectChange"
				>
				</v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Puesto que lo Remplaza</label>
				<v-select
					solo
					multiple
					chips
					deletable-chips
					autocomplete
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="jobList"
					v-model="jobCopied.additionalInformation.jobItReplaces"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Cantidad de puestos</label>
				<v-text-field
					solo
					class="input-text"
					type="number"
					v-model="jobCopied.quantityPerson"
					@input="onSelectChange"
				></v-text-field>
			</div>
		</div>
		<add-area-dialog
			ref="addAreaDialog"
			@addNewArea="addNewArea">
		</add-area-dialog>
	</div>
</template>

<script>
import addAreaDialog from '@/modules/job-profile/components/jobs-profile/job-info-edition/add-area-dialog';
import appButton from '@/components/shared/app-button';
import { mapState } from 'vuex';
import { clone, pathOr } from 'ramda';

// Funciones removidas - los grupos ahora vienen del store

export default {
	name: 'guideline-job-level-selector',
	components: {
		addAreaDialog,
		appButton,
	},
	props: {
		levelInfo: {
			default: () => ({}),
		},
		selectedJob: {
			default: () => ({}),
		},
	},
	watch: {
		selectedJob: {
			deep: true,
			handler(val) {
				// eslint-disable-next-line no-console
				console.log('[WATCH] jobHeReplaces:',
					(val && val.additionalInformation && val.additionalInformation.jobHeReplaces)
						? val.additionalInformation.jobHeReplaces.map(j => j.name || j)
						: 'N/A');
				const jobAddInf = clone(val);
				if (!jobAddInf.additionalInformation) {
					jobAddInf.additionalInformation = {
						immediateBoss: null,
						jobHeReplaces: [],
						jobItReplaces: [],
					};
				}
				// Convert objects to IDs and filter out phantom jobs
				// not present in jobList (deleted or invalid references)
				const ai = jobAddInf.additionalInformation;
				if (ai.immediateBoss && typeof ai.immediateBoss === 'object') {
					const bossId = ai.immediateBoss.id;
					ai.immediateBoss = (bossId
						&& this.jobList.some(j => j.id === bossId))
						? bossId : null;
				} else if (!ai.immediateBoss) {
					ai.immediateBoss = null;
				}
				if (Array.isArray(ai.jobHeReplaces)) {
					ai.jobHeReplaces = ai.jobHeReplaces
						.map(r => (r && typeof r === 'object' ? r.id : r))
						.filter(id => id
							&& this.jobList.some(j => j.id === id));
				}
				if (Array.isArray(ai.jobItReplaces)) {
					ai.jobItReplaces = ai.jobItReplaces
						.map(r => (r && typeof r === 'object' ? r.id : r))
						.filter(id => id
							&& this.jobList.some(j => j.id === id));
				}
				this.jobsFilter = this.jobList.filter(j => j.id !== jobAddInf.id);
				this.jobCopied = jobAddInf;
			},
		},
	},
	data() {
		return {
			jobCopied: {
				role: {},
				title: {},
				experience: {},
				areaId: {},
				additionalInformation: {
					immediateBoss: null,
					jobHeReplaces: [],
					jobItReplaces: [],
				},
			},
			jobsFilter: [],
		};
	},
	methods: {
		onSelectChange() {
			// eslint-disable-next-line no-console
			console.log('[onSelectChange] jobHeReplaces:',
				this.jobCopied.additionalInformation.jobHeReplaces);
			// v-model stores IDs (return-object removed).
			// Convert IDs back to {id, name} for the backend/store.
			const ai = this.jobCopied.additionalInformation;
			const findJob = (item) => {
				if (!item) return {};
				const id = typeof item === 'object' ? item.id : item;
				if (!id) return {};
				const job = this.jobList.find(j => j.id === id);
				return job ? { id: job.id, name: job.name } : { id, name: '' };
			};
			const emitData = {
				...this.jobCopied,
				additionalInformation: {
					...ai,
					immediateBoss: findJob(ai.immediateBoss),
					jobHeReplaces: (ai.jobHeReplaces || []).map(findJob),
					jobItReplaces: (ai.jobItReplaces || []).map(findJob),
				},
			};
			this.$emit('selectedJobDataChanged', emitData);
		},
		addArea() {
			this.$refs.addAreaDialog.open();
		},
		async addNewArea(area) {
			const body = area;
			try {
				await this.$httpPraktiko.post('groups', body);
				this.showNotification('Área agregada correctamente');
				this.loadGroups();
				this.$emit('addNewArea', true);
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		...mapState('jobEvaluation', {
			jobList: pathOr([], ['supplies', 'guidelineModel', 'userForm', 'jobList']),
			groups: pathOr([], ['supplies', 'guidelineModel', 'groups']), // Acceso a grupos desde store
		}),
	},
};
</script>

<style lang="scss" scoped>
.job-evaluation-level {
	border-top: solid 1px var(--app-color-gray);
	padding: 20px 40px;
	label {
		color: var(--app-color-info);
	}
}
.btn-tool {
	border-radius: 4px;
	color: white;
	font-family: font(bold);
	height: 34px;
	padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-info-edition/job-level-selector.vue